<template>
  <div data-view="settings">
    <layout-logged-frame :title="$t('settings')" :has-aside="false">
      <template v-slot:content>
        <div class="form-wrapper user-settings-wrapper">
          <Can action="get-notifications" subject="user">
            <UserNotifications
              :user="user"
              class="elevation-1"
              :is-disabled="!canEditNotifications"
            >
              <template v-slot:beforeForm>
                <layout-section-header
                  :title="notificationsTitle"
                  :subtitle="$t('you_can_create_email_notifications')"
                  :trigger-label="notificationsTriggerLabel"
                  :has-trigger="canManageNotifications"
                  @toggle="toggleEdit"
                />
              </template>
            </UserNotifications>
          </Can>

          <BillingAccountsPanel/>

          <Can action="update-account-settings" subject="user">
            <UserEnabledCommunication />
          </Can>

          <Can action="accept-business-contact-join" subject="user">
            <UserSettingsForm />
          </Can>

          <SettingPanel :title="$t('appearance')">
            <div class="d-flex align-center justify-space-between w-100">
              <div class="mr-6 text-body-2">
                {{ $t('use_dark_theme_across_the_app') }}
                <v-chip
                  size="x-small"
                  variant="outlined"
                  color="primary"
                  class="ml-2"
                >
                  {{ $t('beta') }}
                </v-chip>
              </div>
              <v-switch
                v-model="isDarkTheme"
                :aria-label="$t('dark_mode')"
                class="mr-0 flex-grow-0 flex-shrink-0"
                hide-details
                inset
              />
            </div>
          </SettingPanel>
        </div>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import UserNotifications from '../../components/forms/user/Notifications';
  import UserEnabledCommunication from '../../components/forms/user/EnabledCommunication';
  import UserSettingsForm from '../../components/forms/user/Settings';
  import BillingAccountsPanel from '../../components/panels/settings/BillingAccounts';
  import SettingPanel from '../../components/panels/settings/Base';

  export default {
    components: {
      UserNotifications,
      UserEnabledCommunication,
      UserSettingsForm,
      BillingAccountsPanel,
      SettingPanel,
    },
    data() {
      return {
        canEditNotifications: false,
        canEditGeneral: false,
      };
    },
    computed: {
      isDarkTheme: {
        get() {
          return this.$vuetify.theme.global.name === 'dark';
        },
        set(isDark) {
          const mode = isDark ? 'dark' : 'light';
          this.$vuetify.theme.change(mode);
          this.$store.dispatch('theme/setMode', mode);
        },
      },
      user() {
        return this.$store.getters['auth/user'];
      },
      notificationsTitle() {
        return this.canManageNotifications
          ? this.$t('manage_notifications')
          : this.$t('view_notifications');
      },
      notificationsTriggerLabel() {
        return !this.canEditNotifications
          ? this.$t('edit_notifications')
          : this.$t('close');
      },
      canManageNotifications() {
        return this.$ability.can('manage-notifications', 'user');
      },
    },
    methods: {
      toggleEdit() {
        this.canEditNotifications = !this.canEditNotifications;
      },
    },
  };
</script>

<style lang="scss">
  [data-view='settings'] {
    [data-component='notifications'] {
      margin: 16px 0 32px 0;

      .v-input {
        padding-right: 8px;
      }
    }
  }

  .user-settings-wrapper {
    width: 100%;

    .component-header {
      margin-bottom: 16px;
    }
  }
</style>
